import { common } from '../main/common-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import type { PImage } from './aliases'
import { l } from './lodash'

export function setInteractive(image: PImage, rect?: Phaser.Geom.Rectangle) {
  // Clear previous input?
  if (image.input) {
    // && image.input.enabled) {
    // common.getPhaserScene().input.disable(image)
    image.removeInteractive()
  }

  image.scrollFactorX = 0
  image.scrollFactorY = 0
  image.setInteractive(
    rect,
    rect
      ? (_ha, x, y) => {
          return rect.contains(x, y)
        }
      : undefined,
  )
  image.input.cursor = 'pointer'
}

export function setInteractiveCircle(
  image: PImage,
  circle?: Phaser.Geom.Circle,
) {
  // Clear previous input?
  if (image.input) {
    image.removeInteractive()
  }

  image.scrollFactorX = 0
  image.scrollFactorY = 0
  image.setInteractive(
    circle,
    circle
      ? (_ha, x, y) => {
          return circle.contains(x, y)
        }
      : undefined,
  )
  image.input.cursor = 'pointer'
}

export function addOnMouseOver(image: PImage, onMouseOver: () => void) {
  image.on('pointerover', () => {
    onMouseOver()
  })
}

export function addOnMouseOut(image: PImage, onMouseOut: () => void) {
  image.on('pointerout', () => {
    onMouseOut()
  })
}

export function addOnClick(
  image: PImage,
  onClick: (buttonNum: number) => void,
  autoEat: boolean = true,
) {
  image.on('pointerdown', () => {
    if (autoEat) {
      clickEater.tempEat()
    }

    let button = 0
    let scene = common.getPhaserScene()
    if (scene.game.input.activePointer.leftButtonDown()) {
      button = 1
    }
    if (scene.game.input.activePointer.rightButtonDown()) {
      button = 2
    }
    if (scene.game.input.activePointer.middleButtonDown()) {
      button = 3
    }
    onClick(button)
  })
}

export function destroyAllImages(images: PImage[]) {
  l.forEach(images, (c) => {
    c.destroy()
  })
  return []
}
export function destroyImage(image: PImage) {
  if (image) {
    image.destroy()
  }
  return null
}

// imageBackground.on('pointerover', () => {
//   obj.isOver = true
// })
// imageBackground.on('pointerout', () => {
//   obj.isOver = false
//   obj.isMouseDown = false
// })

// imageBackground.on('pointerdown', () => {
//   clickEater.tempEat()

//   let scene = common.getPhaserScene()
//   if (scene.game.input.activePointer.rightButtonDown()) {
//     obj.isMouseRightDown = true
//   } else {
//     obj.isMouseDown = true
//   }
// })
// imageBackground.on('pointerup', () => {
//   clickEater.tempEat()

//   if (obj.isMouseDown) {
//     obj.isMouseDown = false
//     if (obj.imageBackground.visible) {
//       obj.onClick()
//     }
//   }
//   if (obj.isMouseRightDown) {
//     obj.isMouseRightDown = false
//   }
// })
// return obj
// }
